import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-spotlight")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-spotlight")),
  head: () => ({
    meta: [
      { title: "البطاقة المميَّزة · Admin · Lecmo" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
